// Rising offer reminder (Ofertas al Alza post-visit reminder) settings service.
// Standalone from webPortalTemplatesService / meetingAutomationService by design
// — see RisingOfferReminderSettingsService docstring (backend).
// Backend: /api/v1/meetings/rising-offer-reminder-settings/ (GET/PUT, single object).

import { CONVERSATIONS_API_URL, getConversationsAuthToken } from '@/config/env'

const BASE = '/api/v1/meetings/rising-offer-reminder-settings'

export type RisingOfferReminderVariableMappingEntry = {
  position: number
  source_type: 'variable'
  source_key: string
}

export type RisingOfferReminderSettings = {
  enabled: boolean
  offset_minutes: number
  template_name: string
  template_language: string
  body_variable_count: number
  variable_mapping: RisingOfferReminderVariableMappingEntry[]
}

class RisingOfferReminderServiceClient {
  private baseUrl: string

  constructor() {
    this.baseUrl = CONVERSATIONS_API_URL || ''
  }

  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const token = getConversationsAuthToken()
    const response = await fetch(`${this.baseUrl}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Token ${token}` } : {}),
        ...options.headers,
      },
    })

    if (!response.ok) {
      const payload = await response.json().catch(() => ({}))
      const detail =
        (payload as { error?: string }).error ||
        (payload as { detail?: string }).detail ||
        response.statusText
      throw new Error(detail || `HTTP ${response.status}`)
    }

    return response.json() as Promise<T>
  }

  getSettings() {
    return this.request<RisingOfferReminderSettings>(`${BASE}/`)
  }

  updateSettings(input: RisingOfferReminderSettings) {
    return this.request<RisingOfferReminderSettings>(`${BASE}/`, {
      method: 'PUT',
      body: JSON.stringify(input),
    })
  }
}

export const risingOfferReminderService = new RisingOfferReminderServiceClient()
